
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { useToast } from "@/components/ui/use-toast";
import { MessageList } from "@/components/messages/MessageList";
import { BasicInfoSection } from "@/components/client-form/BasicInfoSection";
import { ServiceSection } from "@/components/client-form/ServiceSection";
import { CommunicationSection } from "@/components/client-form/CommunicationSection";
import { DateSection } from "@/components/client-form/DateSection";
import { FormActions } from "@/components/client-form/FormActions";
import { useClientForm } from "@/hooks/useClientForm";
import { format } from "date-fns";

const Generate = () => {
  const [previewMessage, setPreviewMessage] = useState<{
    id: string;
    content: string;
    message_type: "email" | "text";
    created_at: string;
    clients?: {
      client_name: string;
    };
  } | null>(null);
  
  const { toast } = useToast();
  const navigate = useNavigate();
  const { 
    formData, 
    handleFormDataChange,
    isGenerating,
    handleSubmit,
    date,
    setDate 
  } = useClientForm();

  return (
    <div className="min-h-screen p-8 bg-gray-50">
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="space-y-2">
          <h1 className="text-4xl font-bold tracking-tighter">Generate Message</h1>
          <p className="text-gray-600">Fill in the details below to generate a personalized message.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-8">
          <Card className="p-6">
            <div className="space-y-8">
              <BasicInfoSection 
                formData={formData} 
                onFormDataChange={handleFormDataChange} 
              />
              <ServiceSection 
                formData={formData} 
                onFormDataChange={handleFormDataChange} 
              />
              <CommunicationSection 
                formData={formData} 
                onFormDataChange={handleFormDataChange} 
              />
              <DateSection 
                date={date}
                onDateChange={setDate}
              />
            </div>
          </Card>

          <div className="flex items-center justify-end">
            <FormActions isGenerating={isGenerating} />
          </div>
        </form>

        {previewMessage && (
          <div className="pt-8">
            <MessageList 
              messages={[previewMessage]} 
              messageType="email"
              description="Message Preview"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Generate;
